module.exports = __webpack_public_path__ + "img/label_0.f7bc0e99.png";